import { BaseModel } from "../../normalized/models";

export class OrderRow extends BaseModel {
    id: string;
    product: string;
    quantity: number;
    invoiceRowId: string;
}
